import { DataQueueEntityModel } from "src/store/models/entity/dataQueue/entity";
import { DataQueueHelperModel } from "src/store/models/entity/dataQueue/helper";

export const encooDataQueueModels = {
  entity: DataQueueEntityModel,
  helper: DataQueueHelperModel,
};
